import { useEffect, useState } from 'react';
import {
  curatedJetBrainsPlugins,
  JETBRAINS_VENDOR_PLUGINS_ENDPOINT,
  normalizeMarketplacePlugins
} from '../data/jetbrainsPlugins';

export function usePluginCount() {
  const [count, setCount] = useState(curatedJetBrainsPlugins.length);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchPluginCount = async () => {
      try {
        const response = await fetch(JETBRAINS_VENDOR_PLUGINS_ENDPOINT, {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`JetBrains Marketplace responded with ${response.status}`);
        }

        const livePlugins = normalizeMarketplacePlugins(await response.json());

        if (!cancelled && livePlugins.length >= curatedJetBrainsPlugins.length) {
          setCount(livePlugins.length);
        }
      } catch (error) {
        console.warn('Using curated JetBrains plugin count because live marketplace data is unavailable.', error);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchPluginCount();

    return () => {
      cancelled = true;
    };
  }, []);

  return { count, loading };
}
